import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { Badge as BootstrapBadge } from "react-bootstrap";
import "./Badge.scss";

const propTypes = {
  /**
   * Appearance of the Badge
   */
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "light",
  ]),
  /**
   * Badge content
   */
  children: PropTypes.node,
  /**
   * Class to modify default styles
   */
  className: PropTypes.string,
};

const defaultProps = {
  variant: "primary",
  children: null,
  className: "",
};

/**
 * Badge component based on https://react-bootstrap-v4.netlify.app/components/badge/
 */
function Badge(props) {
  const { children, variant, className, ...rest } = props;

  return (
    <BootstrapBadge
      variant={variant}
      className={clsx("Uic-Badge-base", `badge-${variant}`, className)}
      {...rest}
    >
      {children}
    </BootstrapBadge>
  );
}

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

export default Badge;
